module.exports = __webpack_public_path__ + "static/media/atv.e339b771.png";